import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const Prompt = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14922)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#D0F4FF"
          />
          <rect
            x="45.75"
            y="79.75"
            width="74.7924"
            height="32.9064"
            rx="2.24186"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <g clipPath="url(#clip1_1503_14922)">
            <path
              d="M68.1884 96.249C68.1884 100.005 65.453 103.119 61.8774 103.683V98.4243H63.6202L63.9518 96.249H61.8774V94.8374C61.8774 94.2421 62.1672 93.6622 63.0963 93.6622H64.0395V91.8102C64.0395 91.8102 63.1834 91.6632 62.365 91.6632C60.6567 91.6632 59.54 92.705 59.54 94.5911V96.249H57.6409V98.4243H59.54V103.683C55.9644 103.119 53.229 100.005 53.229 96.249C53.229 92.093 56.5779 88.7236 60.7087 88.7236C64.8395 88.7236 68.1884 92.093 68.1884 96.249Z"
              fill="#1877F2"
            />
            <path
              d="M63.6203 98.3658L63.9519 96.2037H61.8775V94.8006C61.8775 94.2091 62.1673 93.6325 63.0964 93.6325H64.0396V91.7918C64.0396 91.7918 63.1836 91.6458 62.3653 91.6458C60.6568 91.6458 59.5401 92.6812 59.5401 94.5558V96.2037H57.641V98.3658H59.5401V103.592C59.9209 103.652 60.3112 103.683 60.7088 103.683C61.1064 103.683 61.4967 103.652 61.8775 103.592V98.3658H63.6203Z"
              fill="white"
            />
          </g>
          <rect
            x="74.1711"
            y="88.7231"
            width="30.6666"
            height="2.99186"
            rx="0.747965"
            fill="#1E1E1E"
          />
          <rect
            x="74.1711"
            y="94.7068"
            width="39.6422"
            height="2.99186"
            rx="0.747965"
            fill="#1E1E1E"
          />
          <rect
            x="74.1711"
            y="100.691"
            width="39.6422"
            height="2.99186"
            rx="0.747965"
            fill="#1E1E1E"
          />
          <rect
            x="33.75"
            y="13.75"
            width="74.7924"
            height="32.9064"
            rx="2.24186"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <g clipPath="url(#clip2_1503_14922)">
            <path
              d="M48.7077 24.0723C50.7048 24.0723 50.9417 24.0798 51.7308 24.116C53.7578 24.2082 54.7046 25.17 54.7968 27.182C54.833 27.9705 54.8398 28.2073 54.8398 30.2044C54.8398 32.2021 54.8323 32.4383 54.7968 33.2268C54.7039 35.237 53.7596 36.2006 51.7308 36.2928C50.9417 36.329 50.7061 36.3365 48.7077 36.3365C46.7107 36.3365 46.4738 36.329 45.6853 36.2928C43.6534 36.2 42.7116 35.2338 42.6193 33.2262C42.5832 32.4377 42.5757 32.2015 42.5757 30.2038C42.5757 28.2067 42.5838 27.9705 42.6193 27.1814C42.7122 25.17 43.6565 24.2076 45.6853 24.1153C46.4744 24.0798 46.7107 24.0723 48.7077 24.0723ZM48.7077 22.7241C46.6764 22.7241 46.4221 22.7328 45.6243 22.769C42.9079 22.8937 41.3983 24.4008 41.2736 27.1197C41.2368 27.9181 41.2281 28.1724 41.2281 30.2038C41.2281 32.2351 41.2368 32.4901 41.273 33.2879C41.3976 36.0042 42.9048 37.5139 45.6236 37.6385C46.4221 37.6747 46.6764 37.6834 48.7077 37.6834C50.7391 37.6834 50.994 37.6747 51.7919 37.6385C54.5057 37.5139 56.0191 36.0067 56.1419 33.2879C56.1787 32.4901 56.1874 32.2351 56.1874 30.2038C56.1874 28.1724 56.1787 27.9181 56.1425 27.1203C56.0203 24.4064 54.5113 22.8943 51.7925 22.7696C50.994 22.7328 50.7391 22.7241 48.7077 22.7241V22.7241ZM48.7077 26.363C46.5866 26.363 44.8669 28.0827 44.8669 30.2038C44.8669 32.3249 46.5866 34.0452 48.7077 34.0452C50.8288 34.0452 52.5485 32.3255 52.5485 30.2038C52.5485 28.0827 50.8288 26.363 48.7077 26.363ZM48.7077 32.697C47.3309 32.697 46.2145 31.5813 46.2145 30.2038C46.2145 28.8269 47.3309 27.7106 48.7077 27.7106C50.0846 27.7106 51.201 28.8269 51.201 30.2038C51.201 31.5813 50.0846 32.697 48.7077 32.697ZM52.7006 25.314C52.2045 25.314 51.8024 25.716 51.8024 26.2115C51.8024 26.707 52.2045 27.1091 52.7006 27.1091C53.1962 27.1091 53.5976 26.707 53.5976 26.2115C53.5976 25.716 53.1962 25.314 52.7006 25.314Z"
              fill="url(#paint0_linear_1503_14922)"
            />
          </g>
          <rect
            x="62.1711"
            y="25.7161"
            width="22.439"
            height="2.99186"
            rx="0.747965"
            fill="#1E1E1E"
          />
          <rect
            x="62.1711"
            y="31.6997"
            width="34.4064"
            height="2.99186"
            rx="0.747965"
            fill="#1E1E1E"
          />
          <rect
            x="76.75"
            y="38.75"
            width="74.7924"
            height="32.9064"
            rx="2.24186"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            d="M88.0175 61.7486H85.1917V52.8673H88.0175V61.7486ZM93.8844 55.4775C93.5544 55.4775 93.2379 55.6071 93.0046 55.8378C92.7712 56.0685 92.6401 56.3815 92.6401 56.7078V61.7486H89.6689V52.8673H92.6401V53.7815C93.3365 53.1985 94.2164 52.8733 95.1287 52.8616C96.972 52.8616 98.2512 54.2126 98.2512 56.7768V61.7486H95.1287V56.7078C95.1295 56.5457 95.0979 56.3851 95.0357 56.2352C94.9735 56.0853 94.882 55.9489 94.7664 55.8341C94.6507 55.7192 94.5133 55.6281 94.362 55.5659C94.2106 55.5037 94.0483 55.4717 93.8844 55.4717V55.4775ZM88.0699 50.0962C88.0699 50.3805 87.9846 50.6584 87.8249 50.8947C87.6652 51.1311 87.4381 51.3153 87.1725 51.4241C86.9069 51.5329 86.6146 51.5614 86.3326 51.5059C86.0507 51.4504 85.7916 51.3136 85.5883 51.1125C85.385 50.9115 85.2466 50.6554 85.1905 50.3766C85.1344 50.0978 85.1632 49.8088 85.2732 49.5462C85.3833 49.2836 85.5696 49.0591 85.8086 48.9012C86.0477 48.7432 86.3287 48.6589 86.6162 48.6589C86.9997 48.662 87.3665 48.8147 87.6366 49.084C87.9067 49.3532 88.0582 49.717 88.0582 50.0962H88.0699Z"
            fill="#0A66C2"
            stroke="#0A66C2"
            strokeWidth="0.139616"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="105.17"
            y="47.7241"
            width="30.6666"
            height="2.99186"
            rx="0.747965"
            fill="#1E1E1E"
          />
          <rect
            x="105.17"
            y="53.708"
            width="18.6991"
            height="2.99186"
            rx="0.747965"
            fill="#1E1E1E"
          />
          <rect
            x="105.17"
            y="59.6917"
            width="24.6828"
            height="2.99186"
            rx="0.747965"
            fill="#1E1E1E"
          />
          <g clipPath="url(#clip3_1503_14922)">
            <path
              d="M152.142 87.2441H206.273C206.273 87.2441 210.784 87.2441 210.784 91.7551V109.799C210.784 109.799 210.784 114.31 206.273 114.31H152.142C152.142 114.31 147.631 114.31 147.631 109.799V91.7551C147.631 91.7551 147.631 87.2441 152.142 87.2441Z"
              fill="#F0F0F0"
              stroke="black"
              strokeWidth="1.78302"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M156.653 96.2661H161.164"
              stroke="black"
              strokeWidth="1.78302"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M156.653 105.288H161.164"
              stroke="black"
              strokeWidth="1.78302"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M170.186 96.2661H174.696"
              stroke="black"
              strokeWidth="1.78302"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M170.186 105.288H188.229"
              stroke="black"
              strokeWidth="1.78302"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M183.718 96.2661H188.229"
              stroke="black"
              strokeWidth="1.78302"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M197.251 96.2661H201.762"
              stroke="black"
              strokeWidth="1.78302"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M197.251 105.288H201.762"
              stroke="black"
              strokeWidth="1.78302"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M149.928 108.786C149.925 107.613 148.945 106.639 147.675 106.545C146.502 106.548 145.528 107.527 145.433 108.797L145.477 125.602C145.482 127.556 146.268 129.508 147.738 130.97C149.207 132.431 151.163 133.208 153.117 133.203L157.416 133.192C160.347 133.184 163.176 131.712 164.831 129.265L170.183 121.142C170.768 120.359 170.765 119.382 170.177 118.602C169.49 117.529 167.829 117.24 166.854 118.024L163.246 120.867L163.209 106.407C163.206 105.234 162.226 104.26 160.956 104.166C159.783 104.169 158.809 105.148 158.715 106.418L158.807 104.366C158.804 103.194 157.824 102.22 156.554 102.125C155.382 102.128 154.407 103.108 154.313 104.378L154.318 106.527C154.315 105.355 153.336 104.381 152.065 104.286C150.893 104.289 149.918 105.269 149.824 106.539L149.928 108.786Z"
              fill="#F8ECDF"
              stroke="black"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M158.716 106.413L158.739 115.206"
              stroke="black"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M154.318 106.527L154.439 115.418"
              stroke="black"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M149.944 115.43L149.927 108.786"
              stroke="black"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M201.072 105.957C201.075 104.784 202.055 103.81 203.325 103.715C204.498 103.718 205.472 104.698 205.567 105.968L205.523 122.773C205.518 124.727 204.732 126.679 203.262 128.141C201.793 129.602 199.837 130.379 197.883 130.374L193.584 130.363C190.653 130.355 187.824 128.882 186.169 126.436L180.817 118.313C180.232 117.53 180.235 116.553 180.823 115.773C181.51 114.7 183.171 114.411 184.146 115.195L187.754 118.037L187.791 103.578C187.794 102.405 188.774 101.431 190.044 101.336C191.217 101.339 192.191 102.319 192.285 103.589L192.193 101.537C192.196 100.365 193.176 99.3905 194.446 99.2961C195.618 99.2991 196.593 100.279 196.687 101.549L196.682 103.698C196.685 102.526 197.664 101.551 198.935 101.457C200.107 101.46 201.082 102.44 201.176 103.71L201.072 105.957Z"
              fill="#F8ECDF"
              stroke="black"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M192.284 103.584L192.261 112.377"
              stroke="black"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M196.682 103.698L196.561 112.589"
              stroke="black"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M201.056 112.601L201.073 105.957"
              stroke="black"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M202.98 34.3931V38.4479C202.98 40.5776 201.188 41.4349 198.5 41.4349C195.812 41.4349 194.02 40.5776 194.02 38.4479V34.3931"
            fill="#E3E3E3"
          />
          <path
            d="M202.98 34.3931V38.4479C202.98 40.5776 201.188 41.4349 198.5 41.4349C195.812 41.4349 194.02 40.5776 194.02 38.4479V34.3931"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M202.234 34.7143C204.022 34.0051 205.553 32.7676 206.62 31.1666C207.687 29.5656 208.241 27.6772 208.208 25.7533C208.162 23.1931 207.124 20.7505 205.313 18.9399C203.503 17.1292 201.06 16.0917 198.5 16.0457C195.94 16.0913 193.497 17.1287 191.686 18.9395C189.875 20.7502 188.838 23.193 188.792 25.7533C188.759 27.6773 189.312 29.5658 190.38 31.1669C191.447 32.768 192.977 34.0055 194.766 34.7143H202.234Z"
            fill="#FFEF5E"
          />
          <path
            d="M198.5 20.8875C200.658 20.9271 202.745 21.6724 204.439 23.0096C206.134 24.3468 207.344 26.2023 207.885 28.2923C208.107 27.4645 208.216 26.6104 208.208 25.7533C208.162 23.1931 207.124 20.7505 205.313 18.9399C203.503 17.1292 201.06 16.0917 198.5 16.0457C195.94 16.0913 193.497 17.1287 191.686 18.9395C189.875 20.7502 188.838 23.193 188.792 25.7533C188.784 26.6104 188.892 27.4646 189.115 28.2923C189.656 26.2023 190.866 24.3468 192.561 23.0096C194.255 21.6724 196.342 20.9271 198.5 20.8875Z"
            fill="#FFF9BF"
          />
          <path
            d="M202.234 34.7143C204.022 34.0051 205.553 32.7676 206.62 31.1666C207.687 29.5656 208.241 27.6772 208.208 25.7533C208.162 23.1931 207.124 20.7505 205.313 18.9399C203.503 17.1292 201.06 16.0917 198.5 16.0457C195.94 16.0913 193.497 17.1287 191.686 18.9395C189.875 20.7502 188.838 23.193 188.792 25.7533C188.759 27.6773 189.312 29.5658 190.38 31.1669C191.447 32.768 192.977 34.0055 194.766 34.7143H202.234Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M198.5 41.4348V43.675"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M198.5 34.2662V27.9936L195.513 25.0066"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M194.02 37.7012H202.98"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M198.5 9.32495V12.3119"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M182.072 24.2598H185.493"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M185.805 13.0586L188.792 16.0456"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M214.928 24.2598H211.507"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M211.195 13.0586L208.208 16.0456"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M198.5 27.9936L201.487 25.0066"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1503_14922"
            x1="51.8243"
            y1="22.7241"
            x2="46.5444"
            y2="36.7667"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5E5CCB" />
            <stop
              offset="0.18214"
              stopColor="#8D40B7"
            />
            <stop
              offset="0.431696"
              stopColor="#DA2E7C"
            />
            <stop
              offset="0.753527"
              stopColor="#F15544"
            />
            <stop
              offset="1"
              stopColor="#FECA66"
            />
          </linearGradient>
          <clipPath id="clip0_1503_14922">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_1503_14922">
            <rect
              width="14.9593"
              height="14.9593"
              fill="white"
              transform="translate(53.2281 88.7231)"
            />
          </clipPath>
          <clipPath id="clip2_1503_14922">
            <rect
              width="14.9593"
              height="14.9593"
              fill="white"
              transform="translate(41.2281 22.7241)"
            />
          </clipPath>
          <clipPath id="clip3_1503_14922">
            <rect
              width="79.6415"
              height="63"
              fill="white"
              transform="translate(140 79)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
